export default "__VITE_PUBLIC_ASSET__37a891ce__"